import Image from "next/image";

export function AuthCover() {
  return (
    <aside className="relative isolate hidden shrink-0 flex-col overflow-hidden bg-authCover px-6 py-8 text-white md:flex md:min-h-dvh md:w-[38%] md:max-w-[520px] md:px-9 md:py-10 lg:w-[30%]">
      <Image
        src="/auth_bg.png"
        alt=""
        fill
        priority
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-20 object-cover object-left-bottom mix-blend-screen"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-[-10%] -z-10 blur-xl bg-[image:var(--auth-cover-glow)]"
      />
      <Image
        src="/ImplementAI_main_logo_dark.svg"
        alt="Implement AI"
        width={160}
        height={32}
        className="relative z-10 mb-8 h-auto w-32 md:mb-14 md:w-40"
        priority
      />
      <h2 className="relative z-10 mt-auto mb-5 text-[clamp(20px,2.6vw,42px)] font-extrabold leading-snug tracking-tight">
        Grow your workforce.
        <span className="block bg-gradient-to-r from-primary to-pink bg-clip-text text-transparent">
          Not your payroll.
        </span>
      </h2>
      <p className="relative z-10 mb-auto max-w-[420px] text-sm leading-relaxed text-white/80 md:text-[15px]">
        AI Agents that work in the real world, handling support, sales, and
        operations alongside your team, 24/7.
      </p>
    </aside>
  );
}
